import React from "react";
import { DateTimeFormat } from "../../helpers/utils";
import TableBase from "./Base";

const SpinTheWheelGameMessagesTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Game",
			width: 250,
			ellipsis: true,
			render(record) {
				return <span>{record.game.name}</span>;
			},
		},
		{
			title: "Content",
			dataIndex: "content",
			width: 250,
			ellipsis: true,
		},
		{
			title: "Updated At",
			dataIndex: "updated_at",
			width: 200,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 50,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default SpinTheWheelGameMessagesTable;
